"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Layout Service page state enum
 */

var LayoutServicePageState;

(function (LayoutServicePageState) {
  LayoutServicePageState["Preview"] = "preview";
  LayoutServicePageState["Edit"] = "edit";
  LayoutServicePageState["Normal"] = "normal";
})(LayoutServicePageState = exports.LayoutServicePageState || (exports.LayoutServicePageState = {}));